import * as propTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { clearFilterParams } from '../../actions/searchActions';
import { searchWizardPage } from '../../consts/pageTypes';
import { __ } from '../../helpers/TranslationService';
import { IHeader } from '../../interfaces/IHeader';
import { IState } from '../../reducers';
import { IBrandConfig, IConfig } from '../../reducers/pageData';
import { Logo } from '../Header/Logo';
import { SearchCruise } from '../SearchCruise/SearchCruise';
import { ContactBlock } from './ContactBlock';
import { HeaderMainNavBar } from './HeaderMainNavBar';
import { MenuItemList } from './HeaderMainNavigation';

interface IProps {
    items: IHeader;
    config: IConfig;
    brandConfig: IBrandConfig;
    safePayment?: JSX.Element;
}

type Props = IProps & ReturnType<typeof mapStateToProps> & typeof mapDispatchToProps;

export class HeaderDefaultClass extends React.Component<Props> {
    constructor(props) {
        super(props);
    }

    static childContextTypes = {
        countryCode: propTypes.string,
        contentEndpoint: propTypes.string,
        apiHost: propTypes.string,
        brandConfig: propTypes.any,
    };

    getChildContext = () => ({
        countryCode: this.props.countryCode,
        contentEndpoint: null,
        apiHost: this.props.apiHost,
        brandConfig: this.props.brandConfig,
    });

    render() {
        const officeHours = this.props.items.headerContent?.officeHours;

        const firstLine =
            officeHours?.firstLine && officeHours.firstLine.length > 0
                ? officeHours.firstLine
                : __('Mon - Fri: 8am - 6pm Sat: 9am - 3pm', 'dreamlines');
        const secondLine =
            officeHours?.secondLine && officeHours.secondLine.length > 0
                ? officeHours.secondLine
                : '';

        const showCondensedHeader = this.props.pageType === searchWizardPage;

        return (
            <header>
                <div className="container-fluid globalPageheader">
                    <div className="row">
                        <div className="headermain_topbar">
                            <div className="container">
                                <MenuItemList
                                    className="nav navbar-nav navbar-right top-page-header"
                                    items={this.props.items.subNavigation}
                                />
                                <SearchCruise className="hidden-lg" />
                            </div>
                        </div>
                        <div className="container">
                            <div className="row globalPageheader_brandHeight">
                                <div className="globalPageheader_brand col-sm-4">
                                    <Logo
                                        clearFilterParams={this.props.clearFilterParams}
                                        portalId={this.props.brandConfig.portalId}
                                        forceReload={true}
                                    />
                                </div>

                                <div className="globalPageheader_awards col-sm-3 hidden-is hidden-xs text-center">
                                    {this.props.items.headerContent && (
                                        <>
                                            <a
                                                href={this.props.items.headerContent.bestAwardUrl}
                                                target="_blank"
                                                className="safepayment1"
                                            ></a>
                                            <a
                                                href={this.props.items.headerContent.bestPriceUrl}
                                                target="_blank"
                                                className="safepayment2"
                                            ></a>
                                        </>
                                    )}
                                </div>
                                {this.props.countryCode !== 'br' &&
                                    this.props.countryCode !== 'it' && (
                                        <ContactBlock
                                            contactPagePath={this.props.brandConfig.contactPagePath}
                                            phoneNumber={this.props.phoneNumber}
                                            firstLine={firstLine}
                                            secondLine={secondLine}
                                        />
                                    )}
                            </div>
                        </div>
                        {!showCondensedHeader && <HeaderMainNavBar items={this.props.items} />}
                    </div>
                </div>
            </header>
        );
    }
}

const mapDispatchToProps = {
    clearFilterParams,
};

const mapStateToProps = (state: IState) => ({
    apiHost: state.pageData.appConfig.apiHost,
    countryCode: state.pageData.appConfig.countryCode,
    pageType: state.router.pageType,
    phoneNumber: state.pageData.brandConfig.phoneNumber,
});

export const HeaderDefault = connect(mapStateToProps, mapDispatchToProps)(HeaderDefaultClass);
